import { sessionSetup } from "SessionSetup"
import { api_link } from "siteConfig";
import axios from "axios";
import { SHA256 } from "crypto-js";

export const sendSMS = async (email, otp) => {
    let url = 'https://'+api_link+'customer_portal_v2/sendOTP'

    let otpsent = await axios({
        method: "post",
        url: url,
        data: {
            "referurl": url,
            "var1": email,
            "var2": otp
        },
        timeout: 5000,
        headers: {
            "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        }
    }).then(resp => {
        console.log(resp)
        if(resp.data.message === 'OTP sent successfully'){
            return true
        }
        else {
            return false
        }
    }).catch(err => {
        console.log(err)
    })

    return otpsent
}

export const loginHandler = async (email, password) => {

    let passed = false
    let salt = 'V8e0BZFb)QUR';

    // Ensure the Email address is lower case
    email = email.toLowerCase();
    // Trim any whitespace from the beginning and end and the Email and Password
    email = email.trim();
    password = password.trim();

    let encryption = SHA256(password+salt).toString();
    let url = 'https://'+api_link+'customer_portal_v2/login'

    await axios({
        method: "post",
        url: url,
        data: {
            "referurl": url,
            "var1": email,
            "var2": encryption
        },
        timeout: 5000,
        headers: {
            "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
            // "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        }
    }).then(resp => {

        // console.log(resp.data)

        if(resp.data.message === 'User locked') {
            alert('User Locked')
            passed = false
        }
        else
        if(resp.data.message === 'User disabled') {
            alert('User Disabled')
            passed = false
        }
        else
        if(resp.data.message === 'Incorrect password' || resp.data.message === 'User not found' || resp.data.message === 'Query failed') {
            alert('Incorrect username or password')
            passed = false
        }
        else {

            let user_id = resp.data.user_id
            let email = resp.data.email
            let fullname = resp.data.fullname
            let admin = resp.data.admin
            let customer_name = resp.data.customer_name
            let contract_id = resp.data.contract_id
            let site_ids = resp.data.site_ids

            sessionSetup(user_id, email, fullname, admin, customer_name, contract_id, site_ids).then(() => {
                
            })

            passed = true
        }
        
    }).catch(err => {
        
    })

    return passed
}